import {Component, inject, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EventService} from '../../../../core/services/event.service';
import {ELearningService} from '../../../../core/services/e-learning.service';
import * as events from 'node:events';
import {MatSelectionList} from '@angular/material/list';
import {EventsService} from '../../../../core/services/events.service';
import {Task, TaskGroupService} from '../../../../core/services/taskGroup.service';

interface TaskContentGroup {
  id: number;
  title: string;
  tasks: Task[];
  selectedTasks: Task[];
}
import moment from 'moment/moment';

@Component({
  selector: 'add-content-modal',
  templateUrl: './add-content-modal.component.html',
  styleUrls: ['./add-content-modal.component.scss'],
  standalone: false
})

export class AddContentModalComponent implements OnInit{
  private eventService = inject(EventService);
  private elearningService = inject(ELearningService);
  private taskService = inject(TaskGroupService);
  organizationId;
  type;
  chosenIds;
  content: any = [];
  selectedItems = [];
  taskGroups: TaskContentGroup[] = [];
  constructor(public dialogRef: MatDialogRef<AddContentModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data){

  }

  ngOnInit(){
    this.organizationId = this.data.organizationId;
    this.type = this.data.type;
    this.chosenIds = this.data.chosenIds;
    if (this.type === 'event') {
      this.getEvents();
    } else if (this.type === 'elearning') {
      this.getElearnings();
    } else if (this.type === 'task') {
      this.getTasks();
    }
  }

  getEvents(){
    this.eventService.getEventsForLearningPaths(this.organizationId).subscribe({
      next: (response: any) => {
        for (let i = 0; i < response.length; i++) {
          let _dates = '';
          let dateForSort = '2222/01/01';
          if (response[ i ]?.eventDates?.length) {
            let divider = ', ';
            if (response[ i ].datesType === 'oneDay') {
              divider = '';
            }
            if (response[ i ].datesType === 'longEvent') {
              divider = ' - ';
            }
            if (response[ i ].datesType === 'fewDays') {
              divider = '/ ';
            }
            if (response[ i ].datesType === 'repeatEvent') {
              divider = ', ';
            }

            let _data = response[ i ].eventDates;

            if (_data.length) {
              dateForSort = moment(_data[ 0 ].date).format('YYYY/MM/DD');
            }


            _data.forEach(el => {
              if (_dates) {
                _dates =
                  _dates +
                  divider +
                  moment(el.date).format('DD.MM.YYYY');
              } else {
                _dates = moment(el.date).format('DD.MM.YYYY');
              }
            });
          }
          response[ i ].dateForShow = _dates;
        }
        this.content = response;
        this.selectedItems = this.content.filter(item => this.chosenIds.includes(item.id));
      },
      error: (err) => {}
    });
  }

  getElearnings() {
    this.elearningService.findByOrganization(this.organizationId).subscribe({
      next: (res: any) => {
        this.content = res;
        this.selectedItems = this.content.filter(item => this.chosenIds.includes(item.id));
      },
      error: (err) => {}
    });
  }

  getTasks(){
    this.taskService.getTask(this.organizationId).subscribe({
      next: (res: Task[]) => {
        this.content = res;
        this.selectedItems = this.content.filter(item => this.chosenIds.includes(item.id));
        const groups = new Map<number, TaskContentGroup>();
        for (const task of res) {
          if (!groups.has(task.taskGroupId)) {
            groups.set(task.taskGroupId, {id: task.taskGroupId, title: task.taskGroup?.title || '—', tasks: [], selectedTasks: []});
          }
          groups.get(task.taskGroupId).tasks.push(task);
          if (this.chosenIds.includes(task.id)) {
            groups.get(task.taskGroupId).selectedTasks.push(task);
          }
        }
        this.taskGroups = Array.from(groups.values());
      },
      error: (err) => {}
    });
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  selectGroupTasks(group: TaskContentGroup, tasks: Task[]) {
    group.selectedTasks = tasks;
    const groupIds = new Set(group.tasks.map(task => task.id));
    this.selectedItems = this.selectedItems.filter(item => !groupIds.has(item.id)).concat(tasks);
  }

  saveContent() {
    this.dialogRef.close(this.selectedItems);
  }
}
